module.exports = __webpack_public_path__ + "img/jueyuanchejian.7aaa8dcf.png";